export const greater = `
███████╗ █████╗ ██╗  ██╗
██╔════╝██╔══██╗╚██╗██╔╝
███████╗███████║ ╚███╔╝
╚════██║██╔══██║ ██╔██╗
███████║██║  ██║██╔╝ ██╗
╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝
`;
